__turbopack_context__.v({
  "updateTaskStatus": "WAHzra_updateTaskStatus",
  "updateTaskStatus__hint": "WAHzra_updateTaskStatus__hint",
  "updateTaskStatus__menu": "WAHzra_updateTaskStatus__menu",
  "updateTaskStatus__trigger": "WAHzra_updateTaskStatus__trigger",
});
